export default __webpack_public_path__ + "static/media/01.cee9620c.jpg";